module.exports = __webpack_public_path__ + "media/bootstrap-icons/bricks-db5d7354.svg";